import { useSelector } from "react-redux";

export type UserPermissions = Record<string, boolean> | null | undefined;

/**
 * The requesting user's platform permission grants.
 *
 * Team info (`team-name/`) now returns these next to `platform_permissions_enabled`, so
 * both halves of a permission check arrive in one payload instead of racing. The
 * `misc-constants` copy stays as a fallback until every environment serves the team-info
 * field; it can be dropped once that has shipped everywhere.
 */
export const useUserPermissions = (): UserPermissions =>
  useSelector(
    ({ team }: any) => team?.info?.user_permissions ?? team?.misc?.user_permissions
  );
